import { useState, useEffect, useRef } from "react";
import axios from "../api/axios";
import images from "../assets/img";
import { t } from "../i18n";
import { attachmentsHref } from "../utils/attachments";
import { Popover, Input, Modal, Ripple, initMDB } from "mdb-ui-kit";
import {
    MDBRow,
    MDBCol,
    MDBSwitch,
    MDBBtn,
    MDBCard,
    MDBCardImage,
    MDBCardBody,
    MDBCardTitle,
    MDBCardText,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
} from 'mdb-react-ui-kit';

initMDB({ Popover, Input, Modal, Ripple });

var selectedCoverings = [];
const imgHref = attachmentsHref + 'covering/';
const POPULAR_COVERING_MODEL = process.env.REACT_APP_LANG === 'sk' ? "classic-p" : "classic-pp";


function CoveringsView(props) {
    const [popularOnly, setPopularOnly] = useState(false);
    const didMount = useRef(false);
    props.coverings?.sort((a, b) => a.barvaPoradi - b.barvaPoradi);
    const popularCovering = process.env.REACT_APP_LANG === 'sk'
        ? props.coverings?.find(covering => covering.model === POPULAR_COVERING_MODEL && covering.hlavni === true)
        : props.coverings?.find(covering => covering.model == POPULAR_COVERING_MODEL && covering.barva == "ebenove_cerna");

    //MODALS
    const [coveringModal, setCoveringModal] = useState(false);
    const [coveringModalHeader, setCoveringModalHeader] = useState();
    const [coveringModalBody, setCoveringModalBody] = useState();
    const [removeCoveringModal, setRemoveCoveringModal] = useState(false);
    const [removeCoveringModalBody, setRemoveCoveringModalBody] = useState();
    const removeCoveringModalHeader = (selectedCoverings.length === 0) ?
        t("covering_remove_all") :
        t("covering_remove_max");

    // SK: Premium / Standard split by typ + org filter
    let concretePremium = props.coverings?.filter(cover => cover.typ === "betonove-premium" && cover.org === process.env.REACT_APP_ORG && cover.hlavni);
    concretePremium?.sort((a, b) => a.modelPoradi - b.modelPoradi);
    let concreteStandard = props.coverings?.filter(cover => cover.typ === "betonove-standard" && cover.org === process.env.REACT_APP_ORG && cover.hlavni);
    concreteStandard?.sort((a, b) => a.modelPoradi - b.modelPoradi);

    // CZ: flat concrete list
    let concrete = [];
    props.coverings?.forEach(krytina => {
        if (krytina.typ == "betonove") {
            if (!concrete.some(bKrytina => bKrytina.model === krytina.model) && krytina.hlavni) {
                concrete.push(krytina);
            }
        }
    })
    concrete.sort((a, b) => a.modelPoradi - b.modelPoradi);

    //Keramicke Tasky
    let ceramic = [];
    props.coverings?.forEach(krytina => {
        if (krytina.typ === "keramicke") {
            if (!ceramic.some(bKrytina => bKrytina.model === krytina.model) && krytina.hlavni) {
                ceramic.push(krytina);
            }
        }
    })
    ceramic.sort((a, b) => a.modelPoradi - b.modelPoradi);

    useEffect(() => {
        let dotaznikCoverings = [];
        selectedCoverings.forEach(covering => {
            let dotCov = {
                pole: covering.pole,
                barva: covering.barva,
                kryti: null,
                model: covering.model,
                modelNazev: covering.modelNazev,
            }
            dotaznikCoverings.push(dotCov);
        })
        props.step.data = { dotaznikCoverings, popularOnly }

        // sync selected covering color to gutter color picker
        if (selectedCoverings[0]) {
            var selectedColor = selectedCoverings[0].barva;
            if (selectedColor != props.selectedCoveringColor) {
                props.stateHandler("selectedCoveringColor", selectedColor);
            }
        }

        if (!didMount.current) {
            didMount.current = true;
            return;
        }
    }, [[selectedCoverings], [removeCoveringModalBody]])



    function popularSelectHandler(e) {
        setPopularOnly(e.target.checked);
        if (e.target.checked) {
            selectedCoverings = [popularCovering];
            let popularCard = document.getElementById(POPULAR_COVERING_MODEL);
            if (popularCard != undefined) {
                popularCard.click();
            }
        } else {
            selectedCoverings = [];
        }
        setPopularOnly(e.target.checked);
    }

    function selectModelColorCards(modelBarvy) {

        return (
            <MDBRow className="g-4" size="12">
                {modelBarvy.map((coloring) => {
                    const selectedMark =
                        (selectedCoverings.find(k => k.modelNazev === coloring.modelNazev && k.barva === coloring.barva) !== undefined)
                            ? "" : "d-none";
                    return (
                        <MDBCol lg='3' md="4" sm="6" key={"select" + coloring.typ + coloring.model + coloring.barva} className=''>
                            <MDBCard className='h-100 modal-card' alignment='center'
                                onClick={() => selectKrytina(coloring)}>
                                <i className={"fas fa-check-circle selected-covering-modal-icon " + selectedMark}></i>
                                <MDBCardImage
                                    src={imgHref + coloring.model + "/" + coloring.obrazek + ".jpg"}
                                    alt='&empty;'
                                    className='modal-card-img'
                                    height='100'
                                />
                                <MDBCardBody className='p-2 mb-2'>
                                    <MDBCardText className=''>{coloring.barvaNazev}</MDBCardText>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    )
                })}
            </MDBRow>
        );
    }

    function showModelColorDialog(selectedModel) {
        setCoveringModalHeader(displayModalIcons(selectedModel.modelNazev, selectedModel.znacky));

        let modelBarvy = props.coverings?.filter(krytina => krytina.typ === selectedModel.typ && krytina.model === selectedModel.model);
        setCoveringModalBody(selectModelColorCards(modelBarvy));
        setCoveringModal(true);
    }

    const displayModalIcons = (header, icons) => {
        let iconsArray = icons?.split(";");
        return (
            <span>
                <span className="me-2">
                    {header}
                </span>
                <span>
                    {iconsArray?.map((icon) => (
                        <img key={images[icon + "_h30"]} src={images[icon + "_h30"]} alt="" height="25" className="pb-1 px-1" ></img>
                    ))}
                </span>
            </span>
        )
    }

    function showRemoveKrytinaCards() {
        return (
            <MDBRow className='g-4'>
                {selectedCoverings.map((covering) => (
                    <MDBCol lg='4' md="4" sm="6" key={"removeKrytina" + covering.typ + covering.model + covering.barva}>
                        <MDBCard className='h-100 modal-card' alignment='center'
                            onClick={() => removeKrytina(covering)} >
                            <MDBCardImage
                                src={imgHref + covering.model + "/" + covering.obrazek + ".jpg"}
                                alt='&empty;'
                                className='modal-card-img'
                            />
                            <MDBCardBody className='mt-1 pb-2 d-grid align-items-start'>
                                <MDBCardTitle>{covering.modelNazev}</MDBCardTitle>
                                <MDBCardText>{covering.barvaNazev}</MDBCardText>
                                <MDBCardText className='align-self-end mt-2'>
                                    <small className='c-red-dark fw-bold'>{t("covering_remove_click")}</small>
                                </MDBCardText>
                            </MDBCardBody>
                        </MDBCard>
                    </MDBCol>
                ))}
            </MDBRow>
        );
    }

    function removeModalCheck() {
        setRemoveCoveringModalBody(showRemoveKrytinaCards());
    }

    function selectKrytina(krytina) {
        if (selectedCoverings.find(k => k === krytina)) {
            selectedCoverings = selectedCoverings.filter(k => krytina !== k);
        } else {
            selectedCoverings.push(krytina)
        }
        removeModalCheck();
        if (selectedCoverings.length > 2) {
            setCoveringModal(false);
            setRemoveCoveringModal(true);
        } else {
            showModelColorDialog(krytina);
        }
    }

    function removeKrytina(krytina) {
        selectedCoverings = selectedCoverings.filter(k => k !== krytina);
        if (selectedCoverings.length <= 2) {
            setRemoveCoveringModal(false);
        }
        removeModalCheck();
    }

    function checkPopularEmpty() {
        if (selectedCoverings.length === 0 && popularOnly) {
            let popularSwitch = document.getElementById('popularCovering');
            popularSwitch.click();
        }
    }

    const displayCardIcons = (icons) => {
        let iconsArray = icons?.split(";");
        return (
            <span className='px-3 mt-2 mb-1'>
                {iconsArray?.map((icon) => (
                    <img key={images[icon + "_h20"] + "h20"} src={images[icon + "_h20"]} alt='' height='16' className='float-end ms-1'></img>
                ))}
            </span>
        );
    }

    function selectedModelsInfo() {
        let priceInfo = t("covering_price_info");
        let samePrice = t("covering_same_price");
        let c1 = selectedCoverings[0];
        let c2 = selectedCoverings[1];
        if (selectedCoverings.length === 1 && c1.modelNazev === "Opál" && c1.barvaNazev !== "Režná") {
            return priceInfo;
        }
        if (selectedCoverings.length > 1) {
            if (c1.model == c2.model) {
                if (c1.modelNazev == "Tegalit STAR" && (c1.barvaNazev == "Granit metalic" || c2.barvaNazev == "Granit metalic")) {
                    return "";
                }
                if (c1.modelNazev == "Classic STAR") {
                    if ((c1.barvaNazev.includes("metalic") && !c2.barvaNazev.includes("metalic"))
                        || (!c1.barvaNazev.includes("metalic") && c2.barvaNazev.includes("metalic"))) {
                        return "";
                    }
                }
                if (c1.modelNazev == "Granát 11" && (c1.barvaNazev == "Režná" || c2.barvaNazev == "Režná")) {
                    return "";
                }
                if (c1.modelNazev == "Granát 13") {
                    if (c1.barvaNazev.includes("ENGOBA") && c2.barvaNazev.includes("ENGOBA")) {
                        return samePrice;
                    }
                    if (c1.barvaNazev.includes("Glazura") && c2.barvaNazev.includes("Glazura")) {
                        return samePrice;
                    }
                    return "";
                }
                if (c1.modelNazev == "Topas 13") {
                    if ((c1.barvaNazev == "ENGOBA měděná" && c2.barvaNazev == "ENGOBA hnědá")
                        || (c2.barvaNazev == "ENGOBA měděná" && c1.barvaNazev == "ENGOBA hnědá")) {
                        return samePrice;
                    }
                    if ((c1.barvaNazev == "Glazura červenohnědá" && c2.barvaNazev == "Glazura tmavě šedá")
                        || (c2.barvaNazev == "Glazura červenohnědá" && c1.barvaNazev == "Glazura tmavě šedá")) {
                        return samePrice;
                    }
                    return "";
                }
                if (c1.modelNazev == "Rubín 9") {
                    if (c1.barvaNazev.includes("ENGOBA") && c2.barvaNazev.includes("ENGOBA")) {
                        return samePrice;
                    } else {
                        return "";
                    }
                }
                if (c1.modelNazev == "Rubín 13") {
                    if ((c1.barvaNazev.includes("tmavohnědá") && c2.barvaNazev.includes("černá"))
                        || (c2.barvaNazev.includes("tmavohnědá") && c1.barvaNazev.includes("černá"))) {
                        return samePrice;
                    } else {
                        return "";
                    }
                }
                if (c1.modelNazev == "Turmalín") {
                    return "";
                }
                if (c1.modelNazev == "Smaragd") {
                    if (c1.barvaNazev.includes("antracitová") || c2.barvaNazev.includes("antracitová")) {
                        return "";
                    }
                }
                if (c1.modelNazev == "Opál") {
                    return priceInfo;
                }
                return samePrice;
            }
        }
        return "";
    }

    const modals = (
        <div key='Coverings Modals'>
            <MDBModal open={coveringModal} onClose={() => { setCoveringModal(false); checkPopularEmpty(); }} tabIndex='-1'>
                <MDBModalDialog centered scrollable size='lg'>
                    <MDBModalContent className='p-2'>
                        <MDBModalHeader>
                            <MDBModalTitle className='text-uppercase'>{coveringModalHeader}</MDBModalTitle>
                            <MDBBtn className='btn-close' color='none' onClick={() => { setCoveringModal(false); checkPopularEmpty(); }}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {coveringModalBody}
                        </MDBModalBody>
                        <MDBModalFooter className='justify-content-between'>
                            <p className='ps-2'>{selectedModelsInfo()}</p>
                            <MDBBtn color='primary' className='fs-6' size='' onClick={() => { setCoveringModal(false); checkPopularEmpty(); }}>
                                {t("covering_confirm_btn")}
                            </MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            <MDBModal staticBackdrop open={removeCoveringModal} tabIndex='-1'>
                <MDBModalDialog centered size='lg'>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle className=''>{removeCoveringModalHeader}</MDBModalTitle>
                        </MDBModalHeader>
                        <MDBModalBody className='pb-4'>
                            {removeCoveringModalBody}
                        </MDBModalBody>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    );

    if (process.env.REACT_APP_LANG === 'sk') {
        return (
            <div>
                <h3 className='c-primary nadpis mt-4'>{t("covering_concrete_header")}</h3>
                <MDBRow className="mt-3 mx-2">
                    <MDBRow className="bg-tasky-premium py-2 c-white">
                        <MDBCol size="8" className="fs-5 align-content-center">PRÉMIUM - zvýšená ochrana a atraktívny lesklý vzhľad</MDBCol>
                    </MDBRow>
                    <MDBRow className='g-3 my-2' size="12">
                        {concretePremium?.map((covering) => {
                            const selectedMark = (selectedCoverings.find(k => k.modelNazev === covering.modelNazev) !== undefined) ? "" : " d-none";
                            const inactive = (popularOnly && covering.model != popularCovering?.model) ? " pe-none" : "";
                            return (
                                <MDBCol md="2" sm="6" key={"premium" + covering.typ + covering.model + covering.barva} className="mt-0">
                                    <MDBCard className={'h-100' + inactive} alignment='center' id={covering.model}
                                        onClick={() => showModelColorDialog(covering)}>
                                        {displayCardIcons(covering.znacky)}
                                        <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                        <MDBCardImage
                                            src={imgHref + covering.model + "/" + covering.obrazek + ".jpg"}
                                            alt='&empty;'
                                            position='top'
                                            className='px-3'
                                        />
                                        <MDBCardBody className='py-1'>
                                            <MDBCardTitle className='fs-6'>{covering.modelNazev}</MDBCardTitle>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>
                            )
                        })}
                    </MDBRow>
                </MDBRow>
                <MDBRow className="mt-3 mx-2">
                    <MDBRow className="bg-tasky-standard py-2 c-white">
                        <MDBCol size="8" className="fs-5 align-content-center">ŠTANDARD - spoľahlivá ochrana za dostupnú cenu</MDBCol>
                    </MDBRow>
                    <MDBRow className='g-3 my-2' size="12">
                        {concreteStandard?.map((covering) => {
                            const selectedMark = (selectedCoverings.find(k => k.modelNazev === covering.modelNazev) !== undefined) ? "" : " d-none";
                            const inactive = (popularOnly && covering.model != popularCovering?.model) ? " pe-none" : "";
                            return (
                                <MDBCol md="2" sm="6" key={"standard" + covering.typ + covering.model + covering.barva} className="mt-0">
                                    <MDBCard className={'h-100' + inactive} alignment='center' id={covering.model}
                                        onClick={() => showModelColorDialog(covering)}>
                                        {displayCardIcons(covering.znacky)}
                                        <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                        <MDBCardImage
                                            src={imgHref + covering.model + "/" + covering.obrazek + ".jpg"}
                                            alt='&empty;'
                                            position='top'
                                            className='px-3'
                                        />
                                        <MDBCardBody className='py-1'>
                                            <MDBCardTitle className='fs-6'>{covering.modelNazev}</MDBCardTitle>
                                        </MDBCardBody>
                                    </MDBCard>
                                </MDBCol>
                            )
                        })}
                    </MDBRow>
                </MDBRow>

                <h3 className='c-primary mt-5 nadpis'>{t("covering_ceramic_header")}</h3>
                <MDBRow className='g-3 mx-2' size="12">
                    {ceramic.map((covering) => {
                        const selectedMark = (selectedCoverings.find(k => k.modelNazev === covering.modelNazev) !== undefined) ? "" : "d-none";
                        const inactive = (popularOnly && covering.model != popularCovering?.model) ? " pe-none" : "";
                        return (
                            <MDBCol md="2" sm="6" key={"keramicke" + covering.typ + covering.model + covering.barva}>
                                <MDBCard className={'h-100' + inactive} alignment='center' id={covering.model}
                                    onClick={() => showModelColorDialog(covering)}>
                                    {displayCardIcons(covering.znacky)}
                                    <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                    <MDBCardImage
                                        src={imgHref + covering.model + "/" + covering.model + ".jpg"}
                                        alt='&empty;'
                                        position='top'
                                        className='px-3'
                                    />
                                    <MDBCardBody className='py-1'>
                                        <MDBCardTitle>{covering.modelNazev}</MDBCardTitle>
                                    </MDBCardBody>
                                </MDBCard>
                            </MDBCol>
                        )
                    })}
                </MDBRow>

                {modals}
            </div>
        );
    }

    // CZ: flat concrete + popularOnly switch
    return (
        <div>
            <MDBRow className='mt-3 mb-5'>
                <MDBSwitch id='popularCovering' name='popularCovering' labelClass='col-11' wrapperClass='d-flex align-items-center'
                    label={t("covering_popular_switch")}
                    defaultChecked={popularOnly} onClick={(e) => { popularSelectHandler(e); }} />
            </MDBRow>

            <h5 className='c-primary nadpis'>{t("covering_concrete_header")}</h5>
            <MDBRow className='g-3 my-2' size="12">
                {concrete.map((covering) => {
                    const selectedMark = (selectedCoverings.find(k => k.modelNazev === covering.modelNazev) !== undefined) ? "" : " d-none";
                    const inactive = ((popularOnly && covering.model != popularCovering?.model) || (!covering.modelDostupny)) ? " pe-none" : "";
                    const unavailable = (!covering.modelDostupny) ? "" : " d-none";
                    return (
                        <MDBCol md="2" sm="6" key={covering.typ + covering.model + covering.barva}>
                            <MDBCard className={'h-100' + inactive} alignment='center' id={covering.model}
                                onClick={() => showModelColorDialog(covering)}>
                                <div className={"unavailableCovering" + unavailable}>{t("covering_unavailable")}</div>
                                {displayCardIcons(covering.znacky)}
                                <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                <MDBCardImage
                                    src={imgHref + covering.model + "/" + covering.obrazek + ".jpg"}
                                    alt='&empty;'
                                    position='top'
                                    className='px-3'
                                />
                                <MDBCardBody className='py-1'>
                                    <MDBCardTitle className='fs-6'>{covering.modelNazev}</MDBCardTitle>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    )
                })}
            </MDBRow>

            <h5 className='c-primary mt-4 nadpis'>{t("covering_ceramic_header")}</h5>
            <MDBRow className='g-3' size="12">
                {ceramic.map((covering) => {
                    const selectedMark = (selectedCoverings.find(k => k.modelNazev === covering.modelNazev) !== undefined) ? "" : "d-none";
                    const inactive = ((popularOnly && covering.model != popularCovering?.model) || (!covering.modelDostupny)) ? " pe-none" : "";
                    const unavailable = (!covering.modelDostupny) ? "" : " d-none";
                    return (
                        <MDBCol md="2" sm="6" key={covering.typ + covering.model + covering.barva}>
                            <MDBCard className={'h-100' + inactive} alignment='center' id={covering.model}
                                onClick={() => showModelColorDialog(covering)}>
                                <div className={"unavailableCovering" + unavailable}>{t("covering_unavailable")}</div>
                                {displayCardIcons(covering.znacky)}
                                <i className={"fas fa-check-circle selected-covering-icon " + selectedMark}></i>
                                <MDBCardImage
                                    src={imgHref + covering.model + "/" + covering.obrazek + ".jpg"}
                                    alt='&empty;'
                                    position='top'
                                    className='px-3'
                                />
                                <MDBCardBody className='py-1'>
                                    <MDBCardTitle>{covering.modelNazev}</MDBCardTitle>
                                </MDBCardBody>
                            </MDBCard>
                        </MDBCol>
                    )
                })}
            </MDBRow>

            {modals}
        </div>
    );
}


const Coverings = (props) => {
    const [coverings, setCoverings] = useState();
    const didLoad = useRef(false);

    useEffect(() => {
        if (didLoad.current) return;
        let isMounted = true;
        const controller = new AbortController();

        const getCoverings = async () => {
            try {
                const response = await axios.get('/krytiny/get', {
                    signal: controller.signal
                });
                didLoad.current = true;
                isMounted && setCoverings(response.data);
            } catch (err) {
                //
            }
        }

        getCoverings();

        return () => {
            isMounted = false;
            controller.abort();
        }
    }, []);

    return (
        <CoveringsView coverings={coverings} {...props} />
    );
};

export default Coverings;
